function checkCartAndRecommendations(cart) {
  let giftThresholdMinimum = document.querySelector("[data-gift-minimum]");
  if (giftThresholdMinimum) {
    giftThresholdMinimum = parseInt(giftThresholdMinimum.dataset.giftMinimum) * 100;
  }

  if (cart.original_total_price > giftThresholdMinimum) {
    let giftProducts = document.querySelectorAll("[data-gift-product]");
    giftProducts.forEach((giftProduct) => {
      giftProduct.removeAttribute("hidden");
    });
  } else {
    let giftProducts = document.querySelectorAll("[data-gift-product]");
    giftProducts.forEach((giftProduct) => {
      giftProduct.setAttribute("hidden", '');
    });
  }

  // Get all recommendation product IDs
  let recommendationIds = Array.from(document.querySelectorAll("[data-product-recommendation-id]")).map(el => el.dataset.productRecommendationId);

  // Check if all recommendation products are in the cart
  let allRecommendationsInCart = recommendationIds.every(id => cart.items.some(item => item.product_id == id));

  // If all recommendation products are in the cart, hide the recommendations
  let recommendationsElement = document.querySelector(".cart-drawer__recommendations");

  if (recommendationsElement) {
    if (allRecommendationsInCart) {
      recommendationsElement.style.display = 'none';
    } else {
      recommendationsElement.style.display = 'block';
    }
  }
}

// Listen for cart:change event
document.addEventListener("cart:change", function (event) {
  let cart = event.detail.cart;
  checkCartAndRecommendations(cart);
});

// Check cart and recommendations on page load
document.addEventListener("DOMContentLoaded", function () {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => checkCartAndRecommendations(cart));
});